export default __webpack_public_path__ + "static/media/ourclient12.4666190b.png";